import React from 'react';
import { Options } from '../types/product';
import { WizardAction, WizardState } from '../types/WigWizard';

export function selectNewColorIfNonExistant(options: Options[], state: WizardState, dispatch: React.Dispatch<WizardAction>) {
  if (options) {
    const colorExist = options.find(option => option.name === 'Color').values.indexOf(state.Color as string);
    if (colorExist === -1)
      dispatch({
        type: 'Color', value: options.find(option => option.name === 'Color').values[0]
      });
  }
}
